module.exports = (function(){
  const local = {
    apiUrl: 'http://localhost:3001/api/v1',
    baseUrl: 'http://localhost:3000/'
  }

  const remote = {
    prod: {
      apiUrl: 'https://consent-api.levelupify.com/api/v1',
      baseUrl: 'https://consent.levelupify.com'
    },
    dev: {
      apiUrl: 'https://consent-api.levelupify.fun/api/v1',
      baseUrl: 'https://consent.levelupify.fun'
    }
  }

  const isLocal = () => {
    return /^localhost/.test(window.location.hostname);
  }

  const isDev = () => {
    return window.location.hostname.indexOf('levelupify.fun') > -1
  }

  const getProperty = (name) => {
    var data = isLocal() ? local : remote;
    if (!isLocal()) {
      if (isDev()) {
        return data['dev'][name]
      } else {
        return data['prod'][name]
      }
    }
    return data[name];
  }

  return {
    isLocal: isLocal(),
    isDev: isDev(),
    apiUrl: getProperty('apiUrl'),
  }
})()


// WEBPACK FOOTER //
// ./src/config.js